import { useEffect, useMemo, useState } from 'react';

import { t } from 'i18next';
import _ from 'lodash';

import ClassDropDown from 'components/Header/components/ClassDropDown/ClassDropDown';
import { getSubjectsThunk, studySubjectsState } from 'redux/study/studySubjects.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';

interface iSelectedClass {
  handleSelect: any;
  selectedId: string;
}

const SelectClass: React.FC<iSelectedClass> = ({ handleSelect, selectedId }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const subjects = useAppSelector(studySubjectsState);

  const [groupedSubjects, setGroupedSubjects] = useState({});

  useEffect(() => {
    dispatch(getSubjectsThunk(user.id));
  }, []);

  const selected = useMemo(() => {
    if (!selectedId) {
      return {
        title: t('common:SelectClass'),
      };
    }

    const selectedObject = _.find(subjects.subjects, obj => {
      return obj.teaching_structure.parent.id === selectedId;
    });

    if (!selectedObject) {
      return {
        title: t('common:SelectClass'),
      };
    }

    return selectedObject.teaching_structure.parent;
  }, [selectedId]);

  useEffect(() => {
    setGroupedSubjects(_.groupBy(subjects.subjects, obj => obj.teaching_structure.parent.title));
  }, [subjects]);

  function printStructure() {
    return Object.keys(groupedSubjects).map(obj => {
      return (
        <div
          className="pointer text text-normal"
          key={groupedSubjects[obj][0].teaching_structure_id}
          onClick={() => {
            handleSelect({
              id: groupedSubjects[obj][0].teaching_structure.parent.id,
              title: obj,
            });
          }}
        >
          {obj}
        </div>
      );
    });
  }

  return (
    <>
      <label htmlFor="structure">{t('common:SelectClass')}</label>
      <ClassDropDown
        style={{ width: '100%' }}
        styleDropDown={{ width: '100%' }}
        value={selected.title ?? 'Select'}
      >
        {printStructure()}
      </ClassDropDown>
    </>
  );
};

export default SelectClass;
